import { useMutation, useQueryClient } from '@tanstack/react-query'
import toast from 'react-hot-toast'
import { useFetchWithAuth } from '../session/useFetchWithAuth'

const URL = import.meta.env.VITE_EPC_API_URL ?? ''

/**
 * Hook to delete an unavailability period
 */
export const useDeleteUnavailabilityPeriod = () => {
  const fetchWithAuth = useFetchWithAuth()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (periodId: string): Promise<{ message: string }> => {
      const response = await fetchWithAuth(
        `${URL}/profile/unavailability/${periodId}`,
        {
          method: 'DELETE',
          headers: { 'Content-Type': 'application/json' },
        }
      )
      return response
    },
    onSuccess: (_data, periodId) => {
      // Invalidate the unavailability periods query to refetch the data
      queryClient.invalidateQueries({ queryKey: ['unavailabilityPeriods'] })
      // Remove the specific period query from the cache
      queryClient.removeQueries({
        queryKey: ['unavailabilityPeriod', periodId],
      })
      toast.success('Unavailability period deleted successfully')
    },
    onError: (error) => {
      console.error('Error deleting unavailability period:', error)
      toast.error(error.message || 'Failed to delete unavailability period')
    },
  })
}
